import React, { createContext, useContext, useState, useCallback } from "react";

export const UI = {
  en: {
    nav_home: "Home", nav_about: "About", nav_sectors: "Sectors", nav_ventures: "Joint Ventures",
    nav_leadership: "Leadership", nav_offices: "Offices", nav_contact: "Contact", nav_news: "News & Insights",
    menu: "Menu", close: "Close",
    hero_cta_primary: "Explore Our Sectors", hero_cta_secondary: "Our Joint Ventures",
    scroll: "Scroll",
    sectors_eyebrow: "Core Sectors", sectors_title: "Five pillars, one sovereign vision",
    sectors_sub: "Resource optimization, infrastructure and public-private integration across every discipline we hold.",
    ventures_eyebrow: "Strategic Alliances", ventures_title: "Three ventures, three markets",
    ventures_sub: "From pharmaceutical manufacturing in Egypt to steel trading across MENA and development management in the GCC.",
    jv_launch: "Established", jv_partner: "Partner", jv_origin: "Partner Origin", jv_region: "Region", jv_with: "In partnership with",
    chairman_eyebrow: "From the Chairman",
    reach_eyebrow: "Our Presence", reach_title: "Rooted in Abu Dhabi, invested across Egypt",
    reach_sub: "Headquarters in the Ministries Complex Area of Abu Dhabi, with a regional office in Cairo serving the group's Egyptian operations.",
    hq_badge: "Headquarters", rep_badge: "Regional Office",
    cta_button: "Start a Conversation",
    footer_quick: "Quick Links", footer_contact: "Get in Touch", footer_sectors: "What We Hold",
    rights: "All rights reserved.",
    about_eyebrow: "About the Group", about_title: "A national investment group, built to endure",
    mission: "Mission", vision: "Vision",
    governance_eyebrow: "Governance", governance_title: "Sovereign standards, institutional discipline",
    governance_body: "Over 700 employees operate under investor-side governance disciplines across every venture — from steel trading platforms to development management for large-scale land banks.",
    sectors_capabilities: "Capabilities",
    sectors_detail_eyebrow: "What We Hold", sectors_detail_title: "Disciplines across the group",
    ventures_page_eyebrow: "Joint Ventures", ventures_page_title: "Strategic joint ventures",
    leaders_eyebrow: "Leadership", leaders_title: "The people behind Al Qalaa",
    partners_eyebrow: "Our Partners", partners_title: "Who we build with",
    spotlight_eyebrow: "Strategic Partner",
    spotlight_cta: "The partnership in full",
    spotlight_visit: "Visit their website",
    spotlight_scale: "Their scale",
    spotlight_approvals: "Approvals & certifications",
    spotlight_reach_eyebrow: "Where it shows",
    spotlight_reach_title: "Inside every project the group undertakes",
    spotlight_reach_sub: "The partnership is not confined to one venture. It sits inside the group's investment decisions and runs through the execution of each programme it commits to.",
    spotlight_reach_cta: "See the joint ventures",
    spotlight_chip: "With Stancor Group",
    spotlight_footer: "Strategic partner",
    offices_eyebrow: "Our Offices", offices_title: "Where you will find us",
    map_eyebrow: "On the ground", map_title: "Offices, plants and projects",
    map_sub: "Every site the group owns, operates or is building, across the United Arab Emirates and Egypt. Select a pin to see what sits there.",
    office_phone: "Direct line",
    contact_eyebrow: "Contact", contact_title: "Start a conversation",
    contact_sub: "Tell us about your project, partnership or investment interest — the group team will respond promptly.",
    form_name: "Full Name", form_email: "Email Address", form_phone: "Phone", form_company: "Company / Organization",
    form_inquiry: "Inquiry Type", form_message: "Your Message", form_send: "Send Message", form_sending: "Sending...",
    form_success: "Your message has been sent. We will be in touch soon.",
    inquiry_general: "General Inquiry", inquiry_investment: "Investment Opportunities", inquiry_partnership: "Partnership Proposal", inquiry_media: "Media Request",
    address_label: "Headquarters Address", email_label: "Email", phone_label: "Phone",
    not_found: "This page could not be found.", back_home: "Back to Home",
    admin_login: "Admin Sign In", admin_email: "Email", admin_password: "Password", admin_sign_in: "Sign In",
    admin_view_site: "View Site", admin_logout: "Sign Out",
    sectors_index: "Jump to a sector", sectors_metrics: "At a glance", sectors_related: "Related joint ventures",
    sectors_gallery: "Project gallery",
    jv_view_timeline: "Timeline", jv_view_grid: "Grid", jv_filter_all: "All regions",
    jv_activities: "Key activities", jv_none: "No ventures match this region.",
    jv_network: "Manufacturing & partner network",
    leaders_board: "Executive Board", leaders_advisory: "Advisory Council",
    leader_read_bio: "Read full profile", leader_profile: "View on LinkedIn",
    principles_eyebrow: "Governance Principles", principles_title: "How the group leads",
    contact_offices_label: "Visit an office", contact_map_title: "Find us on the map",
    contact_success_title: "Message received", contact_send_another: "Send another message",
    contact_call: "Call this number", contact_email_us: "Send an email",
    contact_directions: "Get directions",
    news_eyebrow: "Press Room", news_title: "News & insights",
    news_sub: "Announcements, joint venture milestones and the group's thinking on the sectors it operates in.",
    news_all: "All articles", news_featured: "Featured", news_read: "Read article",
    news_back: "All articles", news_none: "No articles in this category yet.",
    news_latest_eyebrow: "Press Room", news_latest_title: "Latest from the group",
    news_view_all: "View all articles", news_next: "Next article", news_related: "Continue reading",
    cat_announcement: "Announcements", "cat_jv-milestone": "JV Milestones", "cat_sector-insight": "Sector Insights",
    gallery_close: "Close gallery", gallery_prev: "Previous image", gallery_next: "Next image",
    hero_prev: "Previous slide", hero_next: "Next slide", hero_slide: "Slide",
  },
  ar: {
    nav_home: "الرئيسية", nav_about: "عن المجموعة", nav_sectors: "القطاعات", nav_ventures: "المشروعات المشتركة",
    nav_leadership: "القيادة", nav_offices: "مكاتبنا", nav_contact: "تواصل معنا", nav_news: "الأخبار والرؤى",
    menu: "القائمة", close: "إغلاق",
    hero_cta_primary: "استكشف قطاعاتنا", hero_cta_secondary: "مشروعاتنا المشتركة",
    scroll: "مرّر للأسفل",
    sectors_eyebrow: "القطاعات الأساسية", sectors_title: "خمس ركائز، ورؤية سيادية واحدة",
    sectors_sub: "تحسين الموارد الوطنية، وبناء البنية التحتية، والتكامل بين القطاعين العام والخاص في كل تخصص نعمل فيه.",
    ventures_eyebrow: "التحالفات الاستراتيجية", ventures_title: "ثلاثة مشروعات، وثلاثة أسواق",
    ventures_sub: "من التصنيع الدوائي في مصر، إلى تجارة الصلب في الشرق الأوسط وشمال أفريقيا، وإدارة التطوير في دول الخليج.",
    jv_launch: "سنة التأسيس", jv_partner: "الشريك", jv_origin: "بلد الشريك", jv_region: "النطاق الجغرافي", jv_with: "بالشراكة مع",
    chairman_eyebrow: "كلمة رئيس مجلس الإدارة",
    reach_eyebrow: "حضورنا", reach_title: "جذورنا في أبوظبي واستثماراتنا تمتد إلى مصر",
    reach_sub: "المقر الرئيسي في منطقة مجمع الوزارات بأبوظبي، إلى جانب مكتب إقليمي في القاهرة يخدم عمليات المجموعة في مصر.",
    hq_badge: "المقر الرئيسي", rep_badge: "مكتب إقليمي",
    cta_button: "ابدأ الحديث معنا",
    footer_quick: "روابط سريعة", footer_contact: "تواصل معنا", footer_sectors: "قطاعاتنا",
    rights: "جميع الحقوق محفوظة.",
    about_eyebrow: "عن المجموعة", about_title: "مجموعة استثمارية وطنية بُنيت لتدوم",
    mission: "رسالتنا", vision: "رؤيتنا",
    governance_eyebrow: "الحوكمة", governance_title: "معايير سيادية وانضباط مؤسسي",
    governance_body: "يعمل أكثر من 700 موظف وفق ضوابط الحوكمة من جانب المستثمر في كل مشروعاتنا، من منصات تجارة الصلب إلى إدارة تطوير مصارف الأراضي واسعة النطاق.",
    sectors_capabilities: "القدرات",
    sectors_detail_eyebrow: "قطاعاتنا", sectors_detail_title: "تخصصات المجموعة وقطاعاتها",
    ventures_page_eyebrow: "المشروعات المشتركة", ventures_page_title: "مشروعات مشتركة استراتيجية",
    leaders_eyebrow: "القيادة", leaders_title: "القيادات التي تقف وراء القلعة الدولية",
    partners_eyebrow: "شركاؤنا", partners_title: "من نبني معهم",
    spotlight_eyebrow: "الشريك الاستراتيجي",
    spotlight_cta: "تفاصيل الشراكة",
    spotlight_visit: "زيارة موقعهم",
    spotlight_scale: "حجم أعمالهم",
    spotlight_approvals: "الاعتمادات والشهادات",
    spotlight_reach_eyebrow: "أين يظهر أثرها",
    spotlight_reach_title: "في صميم كل مشروع تتولاه المجموعة",
    spotlight_reach_sub: "لا تقتصر الشراكة على مشروع واحد، بل تقع في قلب قرارات الاستثمار لدى المجموعة وتمتد إلى تنفيذ كل برنامج تلتزم به.",
    spotlight_reach_cta: "استعرض المشروعات المشتركة",
    spotlight_chip: "مع مجموعة ستانكور",
    spotlight_footer: "الشريك الاستراتيجي",
    offices_eyebrow: "مكاتبنا", offices_title: "أين تجدنا",
    map_eyebrow: "على الأرض", map_title: "المكاتب والمصانع والمشروعات",
    map_sub: "كل موقع تملكه المجموعة أو تديره أو تقوم بإنشائه في الإمارات العربية المتحدة ومصر. اختر أي علامة لمعرفة ما يوجد فيها.",
    office_phone: "خط مباشر",
    contact_eyebrow: "تواصل معنا", contact_title: "ابدأ الحديث معنا",
    contact_sub: "حدّثنا عن مشروعك أو شراكتك أو اهتمامك الاستثماري، وسيعاود فريق المجموعة التواصل معك في أقرب وقت.",
    form_name: "الاسم الكامل", form_email: "البريد الإلكتروني", form_phone: "رقم الهاتف", form_company: "الشركة أو الجهة",
    form_inquiry: "نوع الاستفسار", form_message: "نص الرسالة", form_send: "إرسال الرسالة", form_sending: "جارٍ الإرسال…",
    form_success: "تم إرسال رسالتك بنجاح، وسنعاود التواصل معك قريبًا.",
    inquiry_general: "استفسار عام", inquiry_investment: "فرص استثمارية", inquiry_partnership: "مقترح شراكة", inquiry_media: "طلب إعلامي",
    address_label: "عنوان المقر الرئيسي", email_label: "البريد الإلكتروني", phone_label: "الهاتف",
    not_found: "لم نتمكن من العثور على هذه الصفحة.", back_home: "العودة إلى الرئيسية",
    admin_login: "تسجيل دخول المشرف", admin_email: "البريد الإلكتروني", admin_password: "كلمة المرور", admin_sign_in: "تسجيل الدخول",
    admin_view_site: "عرض الموقع", admin_logout: "تسجيل الخروج",
    sectors_index: "تنقّل بين القطاعات", sectors_metrics: "نظرة سريعة", sectors_related: "المشروعات المشتركة ذات الصلة",
    sectors_gallery: "معرض المشاريع",
    jv_view_timeline: "المسار الزمني", jv_view_grid: "عرض شبكي", jv_filter_all: "جميع المناطق",
    jv_activities: "الأنشطة الرئيسية", jv_none: "لا توجد مشروعات مشتركة في هذه المنطقة.",
    jv_network: "شبكة التصنيع والشركاء",
    leaders_board: "المجلس التنفيذي", leaders_advisory: "المجلس الاستشاري",
    leader_read_bio: "اقرأ السيرة كاملة", leader_profile: "الملف على LinkedIn",
    principles_eyebrow: "مبادئ الحوكمة", principles_title: "منهج المجموعة في القيادة",
    contact_offices_label: "زيارة أحد مكاتبنا", contact_map_title: "موقعنا على الخريطة",
    contact_success_title: "وصلتنا رسالتك", contact_send_another: "إرسال رسالة أخرى",
    contact_call: "اتصل بنا على هذا الرقم", contact_email_us: "راسلنا بالبريد الإلكتروني",
    contact_directions: "احصل على الاتجاهات",
    news_eyebrow: "غرفة الأخبار", news_title: "الأخبار والرؤى",
    news_sub: "إعلانات المجموعة، ومحطات مشروعاتها المشتركة، وقراءاتها في القطاعات التي تعمل فيها.",
    news_all: "جميع المقالات", news_featured: "مقال مميز", news_read: "اقرأ المقال",
    news_back: "جميع المقالات", news_none: "لا توجد مقالات في هذا التصنيف بعد.",
    news_latest_eyebrow: "غرفة الأخبار", news_latest_title: "أحدث ما نشرته المجموعة",
    news_view_all: "عرض جميع المقالات", news_next: "المقال التالي", news_related: "تابع القراءة",
    cat_announcement: "إعلانات", "cat_jv-milestone": "محطات المشروعات المشتركة", "cat_sector-insight": "رؤى القطاعات",
    gallery_close: "إغلاق المعرض", gallery_prev: "الصورة السابقة", gallery_next: "الصورة التالية",
    hero_prev: "الشريحة السابقة", hero_next: "الشريحة التالية", hero_slide: "شريحة",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "en");

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("lang", l);
  }, []);

  const toggle = useCallback(() => setLang(lang === "en" ? "ar" : "en"), [lang, setLang]);

  const t = (key) => UI[lang]?.[key] ?? UI.en[key] ?? key;
  const L = (obj) => {
    if (!obj) return "";
    if (typeof obj === "string") return obj;
    return obj[lang] || obj.en || obj.ar || "";
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, L, dir: lang === "ar" ? "rtl" : "ltr" }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
